import { executeRpc } from './supabaseRpc';

/**
 * Sets the active tenant organization context in the current Supabase session.
 * Used to enforce PostgreSQL Row Level Security (RLS) policies scoped to the tenant.
 */
export async function setCurrentSupabaseOrganization(orgId: string): Promise<void> {
  if (!orgId) {
    throw new Error('Organization ID is required to set Supabase tenant context.');
  }

  await executeRpc('set_current_organization', { org_id: orgId });
}

export class SupabaseOrganizationContextService {
  async setCurrentOrganization(orgId: string): Promise<void> {
    return setCurrentSupabaseOrganization(orgId);
  }
}

export const supabaseOrganizationContext = new SupabaseOrganizationContextService();
